import { loadScript } from '@superbet-group/web.lib.utilities';

import { windowIo } from './types';

declare let window: windowIo;

export function getBlackboxPayload(): string {
    const blackboxContainer = window.IGLOO && window.IGLOO.getBlackbox && window.IGLOO.getBlackbox();
    return blackboxContainer && blackboxContainer.blackbox ? blackboxContainer.blackbox : '';
}

export function setIovationConfig(): void {
    window.io_global_object_name = 'IGLOO';
    window.IGLOO = window.IGLOO || {
        enable_flash: false,
        loader: {
            uri_hook: 'iojs',
            version: 'general5',
        },
    };
}

export async function loadIovation(): Promise<void> {
    setIovationConfig();
    await loadScript(`${window.location.origin}/static/js/iovation-loader.js`, 'iovation-loader');
}
